//@flow
import * as React from 'react';
import AcknowledgeButton from 'app/common/react/components/growth/unauth/signup/AccountRecovery/AcknowledgeButton';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import ResetPasswordButton from 'app/common/react/components/growth/unauth/signup/AccountRecovery/ResetPasswordButton';
import { Box, Text } from 'gestalt';

type Props = {|
  email: string,
  onClose: () => void,
  onPasswordResetSent: () => void,
  socialButtons: React.Node,
|};

export default function SoftBannedModal({
  email,
  onClose,
  onPasswordResetSent,
  socialButtons,
}: Props) {
  return (
    <Modal
      accessibilityCloseLabel={i18n._('close', 'accessible label for button to close modal')}
      accessibilityModalLabel={i18n._(
        'Recover your account',
        'Modal accessibility label for account recovery',
      )}
      heading={i18n._(
        'We protected your account',
        'Modal heading for user who need to recover their accounts',
      )}
      onDismiss={onClose}
      role="alertdialog"
      size="md"
    >
      <Box paddingX={6} marginBottom={4}>
        <Box marginBottom={4}>
          <Text inline leading="tall">
            {i18n._(
              'We noticed some strange activity on your Pinterest account ' +
                'so we reset your password and logged everyone out (including you).',
              'Statement that we detected suspicious activity',
            )}
          </Text>
        </Box>
        <Box marginBottom={4}>
          <Text>
            {i18n._(
              'Reset your password or log in with Facebook or Google to get back into your account',
              'Prompt to take action to reset password or upsell login with Facebook/Google',
            )}
          </Text>
        </Box>
        <ResetPasswordButton email={email} callBack={onPasswordResetSent} />
        {socialButtons}
        <Box marginTop={4}>
          <AcknowledgeButton onClick={onClose} />
        </Box>
      </Box>
    </Modal>
  );
}
